import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";
import { IMG } from "@/lib/images";
import { ArrowRight, HeartPulse } from "lucide-react";

export default function SupportoPsicologico() {
  return (
    <section id="supporto-psicologico" data-testid="supporto-psicologico-section" className="container-site py-20 lg:py-28">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <Reveal>
          <div className="rounded-3xl overflow-hidden border-8 border-white shadow-2xl shadow-brand-blue/10">
            <img
              src={IMG.psychology.url}
              alt={IMG.psychology.alt}
              loading="lazy"
              className="w-full h-[380px] object-cover"
              data-testid="supporto-psicologico-image"
            />
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <span className="eyebrow">
            <HeartPulse className="w-4 h-4" />
            Supporto psicologico
          </span>
          <h2 className="mt-4 text-3xl sm:text-4xl font-extrabold tracking-tight text-brand-ink leading-tight">
            Quando il peso non è solo economico.
          </h2>
          <div className="mt-6 rounded-2xl bg-brand-aqua/10 border-l-4 border-brand-aqua p-6" data-testid="supporto-highlight-box">
            <p className="text-xl font-bold text-brand-ink leading-relaxed">
              "Prima associazione in Italia a offrire supporto psicologico gratuito alle vittime
              del debito. Perché il disagio economico è anche disagio emotivo, e nessuno dovrebbe
              affrontarlo da solo."
            </p>
            <p className="mt-4 text-lg font-extrabold text-brand-aquadark" data-testid="supporto-gratuito-note">
              Il nostro supporto psicologico è completamente gratuito. Nessun costo, nessun
              abbonamento, nessun profitto.
            </p>
          </div>
          <p className="mt-6 text-lg text-slate-600 leading-relaxed" data-testid="supporto-psicologico-text">
            La nostra associazione offre supporto psicologico gratuito grazie alla collaborazione
            della <strong className="text-brand-ink">Dott.ssa V. Graffeo</strong>, psicologa
            professionista. Il servizio è disponibile su appuntamento, previa valutazione della
            richiesta, attualmente per i casi di maggiore necessità.
          </p>
          <ol className="mt-6 space-y-3" data-testid="supporto-processo">
            {[
              ["Raccontaci la tua situazione", "Compila il modulo di richiesta assistenza descrivendo brevemente la tua situazione e il disagio che stai vivendo, spuntando la voce dedicata al supporto psicologico."],
              ["L'associazione valuta la richiesta", "Valutiamo con attenzione ogni richiesta, dando priorità ai casi di maggiore necessità."],
              ["Ti ricontattiamo noi", "Ti comunicheremo giorno e orario in cui verrai chiamato direttamente dalla Dott.ssa V. Graffeo."],
            ].map(([t, d], i) => (
              <li key={t} className="flex gap-4 items-start rounded-2xl bg-brand-mist p-4" data-testid={`supporto-step-${i + 1}`}>
                <span className="w-9 h-9 shrink-0 rounded-full bg-brand-aqua text-white flex items-center justify-center font-extrabold">
                  {i + 1}
                </span>
                <div>
                  <p className="font-bold text-brand-ink">{t}</p>
                  <p className="text-slate-600">{d}</p>
                </div>
              </li>
            ))}
          </ol>
          <div className="mt-6 flex items-center gap-4 rounded-2xl border-2 border-brand-aqua/30 bg-white p-5 shadow-sm" data-testid="supporto-psicologa">
            <span className="w-14 h-14 rounded-full bg-brand-aqua text-white flex items-center justify-center shrink-0">
              <HeartPulse className="w-7 h-7" />
            </span>
            <div>
              <p className="text-sm font-bold uppercase tracking-wider text-slate-500">
                La psicologa dell'associazione
              </p>
              <p className="text-xl font-extrabold text-brand-ink">Dott.ssa V. Graffeo</p>
            </div>
          </div>
          <Link to="/assistenza" className="btn-primary mt-8" data-testid="supporto-cta">
            Richiedi il supporto
            <ArrowRight className="w-5 h-5" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
